var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgELearning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.214,
    height: 150,
    viewBox: "0 0 135.214 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.214,
    height: 150,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.869,40.292c13.809,17.013,28.17,30.38,29.275,44.962,1.1,14.472-11.047,30.159-24.967,42.532-13.809,12.483-29.5,21.763-45.4,22.2-16.018.332-32.257-8.285-44.188-20.768A74.8,74.8,0,0,1,.148,82.934C-.957,65.48,4.124,46.81,15.945,29.908,27.765,12.9,46.435-2.35,62.454.3c16.128,2.541,29.5,23.089,43.415,39.991",
    fill: "#0af"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M119.865,109.376,107.38,91.091V38.516A3.526,3.526,0,0,0,103.864,35H31.424a3.526,3.526,0,0,0-3.516,3.516V91.088L15.424,109.373a3.486,3.486,0,0,0-.175,3.693A3.32,3.32,0,0,0,18.413,115H55.16a3.526,3.526,0,0,0,3.516-3.516v-4.571h18.11v4.571A3.526,3.526,0,0,0,80.3,115h36.571a3.7,3.7,0,0,0,3.164-1.934,3.909,3.909,0,0,0-.175-3.692ZM100.348,88.628H34.941V42.034h65.231V88.628Z",
    fill: "#2b528e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.458,72.452l13.011-5.978v7.737c0,5.627-8.615,7.56-15.823,7.56a32.769,32.769,0,0,1-10.023-1.407c-4.747-1.582-5.8-4.22-5.8-6.155V66.473l13.011,5.978a7.289,7.289,0,0,0,2.814.527A5.044,5.044,0,0,0,70.458,72.452Z",
    fill: "#02e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.128,58.386a2.283,2.283,0,0,1,1.407-2.11l17.407-7.911a1.9,1.9,0,0,1,1.934,0l17.407,7.911a2.286,2.286,0,0,1,0,4.22L68.876,68.407a1.912,1.912,0,0,1-.88.176,1.317,1.317,0,0,1-.879-.176L49.71,60.5A2.209,2.209,0,0,1,48.128,58.386Z",
    fill: "#02e2ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgELearning);
export default __webpack_public_path__ + "static/media/E_learning.227a39067464ef5e83075b0e6a56aabc.svg";
export { ForwardRef as ReactComponent };